import React from "react";
import Navbar from "../components/navbar";
import About from "../components/about";
import Footer from "../components/footer";

const AboutPage = () => {
    return (
        <div>
            <Navbar />
            <About />
            <Footer />
        </div>
    );
}

export default AboutPage;